import {
    GET_LIST_BLOOD_TYPE,
    GET_SPECIFIC_BLOOD_TYPE,
    UPDATE_SPECIFIC_BLOOD_TYPE,
    CREATE_NEW_BLOOD_TYPE,
    REMOVE_BLOOD_TYPE,
    GET_BLOOD_TYPE_ACTIVE
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    blood_type_list: [],
    currentBlood_type_list: null,
    blood_type_active_list: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_BLOOD_TYPE: {
            return {
                ...state,
                blood_type_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_BLOOD_TYPE_ACTIVE: {
            return {
                ...state,
                blood_type_active_list: action.payload?.data || [],
            }
        }
        case GET_SPECIFIC_BLOOD_TYPE: {
            return { ...state, currentBlood_type_list: action.payload }
        }
        case CREATE_NEW_BLOOD_TYPE: {
            return {
                ...state,
                blood_type_list: [action.payload, ...state.blood_type_list],
                blood_type_active_list: [action.payload, ...state.blood_type_active_list],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_BLOOD_TYPE: {
            let index = state.blood_type_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.blood_type_list];
            temp[index] = action.payload;
            //
            let index2 = state.blood_type_active_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp2 = [...state.blood_type_active_list];
            temp[index2] = action.payload;

            return { ...state, blood_type_list: temp, blood_type_active_list: temp2 }
        }
        case REMOVE_BLOOD_TYPE: {
            let temp = state.blood_type_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            let temp2 = state.blood_type_active_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, blood_type_list: temp, blood_type_active_list: temp2 }
        }
        default: return { ...state };
    }
}
